function PerfectButtonIconLeft({ width = 20, height = 20 ,fillColor= "white"}) {
    return (
        <svg width={width} height={height} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 5.83881L10.8235 1.60352M3.76471 10.78L14 10.78M2 15.3682L8 18.8976" stroke={fillColor} stroke-width="2.11765" stroke-linecap="round" />
        </svg>

    )
}

export default PerfectButtonIconLeft;